// extracted by mini-css-extract-plugin
module.exports = {"hand":"styles_hand__3eGrW","isSelected":"styles_isSelected__WHMZA"};